import DocumentViewerModal from "components/DocumentViewer";
import React from "react";
import { FILE_URL, PrivateProsecutionReport } from "types";
import { feedbackIcon } from "utils/constant";

type Props = {
  reports: PrivateProsecutionReport[];
};

const PrivateProsecutionReportSection: React.FC<Props> = ({ reports }) => {
  return (
    <div>
      <h1 className="text-black font-semibold text-lg flex flex-row gap-2 items-center mb-2">
        <span className="text-[#AA232F] text-xl">{feedbackIcon}</span>
        <span className="tracking-wide">Report Section</span>
      </h1>
      <div className="flex flex-col gap-4 mt-2 justify-between h-[70vh] w-full">
        <div className="flex flex-col overflow-y-auto gap-3 pr-1">
          {reports && reports.length > 0 ? (
            reports?.map((report, index) => (
              <div
                key={index}
                className={`flex flex-col items-start gap-3 rounded-lg shadow-sm border border-gray-200 px-4 py-3 ${
                  index % 2 === 0 ? "bg-[#F7F7F7]" : "bg-white"
                }`}
                style={{ overflowWrap: "break-word" }}
              >
                {/* Feedback type icon */}
                <div className="flex-1 mb-4">
                  <p className="text-sm text-gray-700 leading-relaxed mb-1">
                    {report?.private_prosecution_report_summary}
                  </p>
                  <p className="text-xs text-red-500">{report?.created_by}</p>
                </div>

                <DocumentViewerModal
                  documents={report?.documents || ([] as any)}
                  baseUrl={`${process.env.REACT_APP_API_BASE_URL}${FILE_URL.PRIVATE_PROSECUTION}`}
                  layout="list"
                  // label="Letter Upload"
                  hideEmptyFile={true}
                />
              </div>
            ))
          ) : (
            <div className="text-center text-gray-800 py-8">No report yet.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PrivateProsecutionReportSection;
